import { Box, Tooltip, useTheme } from '@material-ui/core';
import { FC, MouseEventHandler } from 'react';
import { CollapseDockablePanelIcon, ExpandDockablePanelIcon } from './icons';

interface Props {
  onClick?: MouseEventHandler<HTMLElement>;
  background?: boolean;
}

export const CollapseButton: FC<Props> = ({ onClick, background = true }) => {
  const theme = useTheme();
  return (
    <Tooltip title="Collapse">
      <Box
        display="flex"
        padding="0px 4px"
        height="100%"
        alignItems="center"
        style={{
          cursor: 'pointer',
          background: background ? theme.palette.softened.primary : undefined,
        }}
        onClick={onClick}
      >
        <CollapseDockablePanelIcon color="primary" style={{ fontSize: 16 }} />
      </Box>
    </Tooltip>
  );
};
interface ExpandButtonProps {
  background?: boolean;
  onClick?: MouseEventHandler<HTMLElement>;
}

export const ExpandButton: FC<ExpandButtonProps> = ({
  background = true,
  onClick,
}) => {
  const theme = useTheme();
  return (
    <Tooltip title="Expand">
      <Box
        display="flex"
        padding="4px"
        height="100%"
        width="100%"
        justifyContent="center"
        alignItems="center"
        style={{
          cursor: 'pointer',
          background: background ? theme.palette.softened.primary : 'none',
          marginTop: background ? 'none' : '22px',
        }}
        onClick={onClick}
      >
        <ExpandDockablePanelIcon color="primary" style={{ fontSize: 16 }} />
      </Box>
    </Tooltip>
  );
};
